<template>
  <div>
    <!-- PC端 -->
    <div v-if="isPC" class="layout" :style="{ paddingLeft: menuCollapse ? '64px' : '208px' }">
      <!-- 左侧菜单 -->
      <div class="menu bg-white" :style="{ width: menuCollapse ? '64px' : '208px' }">
        <!-- logo -->
        <div class="logo f-c-c pointer" @click="jump">
          <img v-show="!menuCollapse" src="../../assets/img/logo.png" style="width: 162px; height: 39px;" />
          <img v-show="menuCollapse" src="../../assets/img/small_logo.png" style="width: 34px; height: 34px;" />
        </div>
        <!-- 菜单关闭按钮 -->
        <div
          class="menu-close-but pointer f-c-c"
          @click="$store.commit('setState', {key: 'menuCollapse', value: !menuCollapse})"
          :style="{ left: menuCollapse ? '46px' : '190px' }"
        >
          <i :class="['iconfont', menuCollapse ? 'icon-a-arrow-right-s-line1' : 'icon-a-arrow-left-s-line2']" style="font-size: 24px;"></i>
        </div>
        <div  style="height:80%;overflow-y:auto;overflow-x:hidden">

          <Menu/>
        </div>
      </div>
      <!-- header -->
      <div class="header f-b-c" :style="{ left: menuCollapse ? '64px' : '208px' }">
        <div></div>
        <div class="f--c" style="height: 100%;">
          <!-- 站内信   新功能查看 -->
          <!-- <div class="pointer news" @click="showNewFunction">
            <el-badge :is-dot="!$store.state.common.newFunctionIsRead" class="item">
              <i class="el-icon-bell iconfont"></i>
            </el-badge>
          </div> -->
          <div class="pointer news">
            <el-popover v-model="showNotify" placement="bottom-end" width="500" :offset="230" trigger="manual">
              <inform-box ref="informBox" id="informBox" @showNewFunction="showNewFunction" />
              <el-badge slot="reference" :is-dot="$store.state.common.newFunctionIsRead" class="item">
                <i class="el-icon-bell" id="headNotify" style="font-size:18px" @click="handleShowNotify()"></i>
              </el-badge>
            </el-popover>
          </div>
          <!-- 帮助icon -->
          <!-- <div class="cart f-c-c pointer" @click="showHelpCenter"><i class="iconfont icon-help pointer"></i></div> -->
          <!-- 购物车icon -->
          <!-- <div class="cart f-c-c pointer" @click="showShoppingCart"><i class="iconfont icon-shopping-cart-2-line pointer"></i></div> -->
          <div class="cart f-c-c pointer" @click="showShoppingCart">
            <i class="iconfont icon-shangpin-gouwudai pointer"></i>
            <span v-show="$store.state.common.shoppingCartSkuNum > 0">{{$store.state.common.shoppingCartSkuNum}}</span>
          </div>
          <!-- 多语言 -->
          <!-- 去除国际化2022.11 -->
          <!-- 添加国际化2023.02 -->
          <div class="language pointer">
            <el-dropdown @command="langChange">
              <div class="language-box f--c">
                <i class="iconfont icon-earth-line"></i> {{$store.state.language}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(value, key) in language" :key="key" :command="key">{{ value }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="user pointer">
            <el-dropdown @command="fun => this[fun]()">
              <span class="f">
                <div class="avatar f-c-c">
                  {{ firstName }}
                  <img v-show="$store.state.common.approvalStatus===3" src="@/assets/img/certificate-icon.svg" alt="">
                </div>
                {{$store.state.common.userName}}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="openAccountSetting">{{$t('currency.accountSettings')}}</el-dropdown-item>
                <el-dropdown-item command="logOut">{{$t('currency.logOut')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <router-view />
      <!-- 购物车侧边栏按钮 -->
      <!-- <div class="shopping-cart-but pointer f-c-c" @click="showShoppingCart">
        <i class="iconfont icon-shangpin-gouwudai pointer"></i>
        <span v-show="$store.state.common.shoppingCartSkuNum > 0">{{$store.state.common.shoppingCartSkuNum > 99 ? '99+' : $store.state.common.shoppingCartSkuNum}}</span>
      </div> -->
      <!-- 购物车 -->
      <ShoppingCart ref="shoppingCart"></ShoppingCart>
      <!-- 帮助中心侧边栏 -->
      <HelpCenter ref="helpCenter"></HelpCenter>
      <!-- 站内信 新功能查看 -->
      <newFunction ref="newFunction"></newFunction>
    </div>
    <!-- 移动端 -->
    <div v-else class="mobile-layout">
      <Header />
      <router-view />
    </div>
  </div>
</template>

<script>
import ShoppingCart from '../ShoppingCart.vue'
import HelpCenter from '../HelpCenter.vue'
import newFunction from '../newFunction.vue'
import Header from '../mobile/Header.vue'
import Menu from '@/components/layout/Menu'
import language from '@/config/language.js'
import menuList from '@/config/menuList.js'
import API from '@/api'
import InformBox from '../InformBox.vue'
import bus from '@/util/bus'

export default {
  data() {
    return {
      language,
      menuList,
      showNotify: false
    }
  },
  components: { ShoppingCart, HelpCenter, Header, Menu, newFunction, InformBox },
  computed: {
    menuCollapse() {
      return this.$store.state.menuCollapse
    },
    firstName() {
      return this.$store.state.common.userName && this.$store.state.common.userName[0].toUpperCase()
    }
  },
  created() {
    if (this.isPC) {
      bus.$on('favoriteExportList', this.favoriteExportList)
    }
  },
  mounted() {
    const headNotify = document.querySelector('#headNotify')
    const informBox = document.querySelector('#informBox')
    const clickShowNotify = (e) => {
      if (this.showNotify && !headNotify.contains(e.target) && !informBox.contains(e.target)) {
        this.showNotify = false
      }
    }
    document.addEventListener('click', clickShowNotify)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', clickShowNotify)
    })
  },
  beforeDestroy() {
    this.$once('hook:beforeDestroy', () => {
      bus.$off('favoriteExportList')
    })
  },
  methods: {
    langChange(language) {
      this.$i18n.locale = language
      this.$store.commit('setState', { key: 'language', value: language })
      history.go()
    },
    showShoppingCart() {
      // this.$refs.shoppingCart.show()
      this.$router.push('/mall/shoppingCar')
    },
    showHelpCenter() {
      this.$refs.helpCenter.show()
    },
    logOut() {
      API.logout().finally(() => {
        this.$store.dispatch('logOut')
      })
    },
    openAccountSetting() {
      this.$router.push('/personal-center/account-setting')
    },
    showNewFunction(tabs, id) {
      // this.$refs.newFunction.show()
      this.$refs.newFunction.show(tabs, id)
    },
    jump() {
      // this.$router.push(process.env.NODE_ENV === 'production' ? '/' : '/mall')
      // this.$router.push('/mall')
      location.href = '/'
    },
    favoriteExportList() {
      setTimeout(() => {
        this.showNotify = true
        this.$refs.informBox.activeName = '4'
        this.$refs.informBox.handleClick()
      }, 500)
    },
    handleShowNotify() {
      this.showNotify = !this.showNotify
      if (this.showNotify) this.$refs.informBox.handleClick()
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 40px 0 0 208px;
}
.menu-close-but {
  border-radius: 100px;
  position: absolute;
  width: 36px;
  height: 36px;
  left: 190px;
  top: 59px;
  z-index: 999;
  background: #ffffff;
  box-shadow: 0px 4px 10px 2px rgba(0, 0, 0, 0.08);
}
.menu {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  z-index: 10;
  border-right: 1px solid #F5F7F7;
}
.header {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  padding-right: 10px;
  background: #99c41c;
  z-index: 2000;
  .cart {
    color: white;
    margin-left: 22px;
    span{
      font-size: 14px;
      padding-left: 5px;
    }
  }
  .news {
    color: white;
    margin-left: 22px;
    span{
      font-size: 14px;
      padding-left: 5px;
    }
  }
  .user {
    .head-portrait{
      display: inline-block;
      width: 18px;
      height: 18px;
      line-height: 19px;
      background: white;
      border-radius: 100px;
      color: #99C41C;
      text-align: center;
      margin-right: 6px;
      vertical-align: middle;
    }
    margin: 0 22px;
  }
  .language{
    margin-left: 22px;
    .language-box{
      height: 40px;
      .icon-earth-line{
        font-size: 24px;
        margin-right: 4.5px;
      }
    }
    .icon-diqiuquanqiu{
      font-size: 18px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }
}

.logo {
  height: 105px;
}
.menu-icon{
  color: black;
  margin-right: 3px;
}
/deep/.el-dropdown{
  color: white;
}

.shopping-cart-but{
  position: fixed;
  top: 118px;
  right: 0;
  width: 60px;
  height: 60px;
  z-index: 1999;

  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 30px 0px 0px 30px;
  span{
    position: absolute;
    top: 15px;
    left: 33px;
    background: #A6100C;
    color: #FFFFFF;
    border-radius: 100px;
    font-size: 10px;
    padding: 0 3.5px;
  }
}
::-webkit-scrollbar {
    width: 2px;
    height: 10px;
}

// 移动端
.mobile-layout{
  padding-top: 75px;
}
.avatar{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  color: #99C41C;
  margin-right: 5px;
  position: relative;
  img{
    width: 11px;
    height: 11px;
    position: absolute;
    top: 60%;
    right: -10%;
  }
}
</style>
